import React from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "services/auth.service";

const ProtectedRoute = ({ children }) => {
  const token = getToken();
  // Chỉ kiểm tra đăng nhập, không kiểm tra role nữa
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedRoute;
